module.exports = __webpack_public_path__ + "static/media/image_56.95cf2162.png";